import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetCustomersAndMovesForLiteQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetCustomersAndMovesForLiteQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, name?: string | null, moves: Array<{ __typename?: 'moves', id: number, cancel_status?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_type?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, delivery_time?: string | null, lite: boolean, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, pickup_time?: string | null, ready_by?: string | null, status?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null } | null } | null, lane?: { __typename?: 'lanes', duration_sec?: number | null, pickup: { __typename?: 'locations', name?: string | null }, delivery: { __typename?: 'locations', name?: string | null } } | null }> }> };


export const GetCustomersAndMovesForLiteDocument = gql`
    query getCustomersAndMovesForLite($start: timestamptz!, $end: timestamptz!) {
  customers(order_by: {name: asc}) {
    id
    name
    moves(
      where: {active: {_eq: 1}, move_type: {_ilike: "drive"}, _or: [{consumer_type: {_is_null: true}}, {consumer_type: {_nilike: "loaner"}}], _and: [{pickup_time: {_gte: $start}}, {pickup_time: {_lte: $end}}]}
      order_by: {pickup_time: asc}
    ) {
      id
      cancel_status
      consumer_name
      consumer_phone
      consumer_type
      delivery_arrived
      delivery_started
      delivery_successful
      delivery_time
      lite
      pickup_arrived
      pickup_started
      pickup_successful
      pickup_time
      ready_by
      status
      vehicle_color
      vehicle_make
      vehicle_model
      vehicle_stock
      vehicle_vin
      vehicle_year
      driver {
        id
        user {
          id
          display_name
          avatar_url
        }
      }
      lane {
        duration_sec
        pickup {
          name
        }
        delivery {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomersAndMovesForLiteQuery__
 *
 * To run a query within a React component, call `useGetCustomersAndMovesForLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersAndMovesForLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersAndMovesForLiteQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetCustomersAndMovesForLiteQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables> & ({ variables: GetCustomersAndMovesForLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>(GetCustomersAndMovesForLiteDocument, options);
      }
export function useGetCustomersAndMovesForLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>(GetCustomersAndMovesForLiteDocument, options);
        }
// @ts-ignore
export function useGetCustomersAndMovesForLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>;
export function useGetCustomersAndMovesForLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersAndMovesForLiteQuery | undefined, GetCustomersAndMovesForLiteQueryVariables>;
export function useGetCustomersAndMovesForLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>(GetCustomersAndMovesForLiteDocument, options);
        }
export type GetCustomersAndMovesForLiteQueryHookResult = ReturnType<typeof useGetCustomersAndMovesForLiteQuery>;
export type GetCustomersAndMovesForLiteLazyQueryHookResult = ReturnType<typeof useGetCustomersAndMovesForLiteLazyQuery>;
export type GetCustomersAndMovesForLiteSuspenseQueryHookResult = ReturnType<typeof useGetCustomersAndMovesForLiteSuspenseQuery>;
export type GetCustomersAndMovesForLiteQueryResult = Apollo.QueryResult<GetCustomersAndMovesForLiteQuery, GetCustomersAndMovesForLiteQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/rooftops/queries/getCustomersAndMovesForLite.query.gql}
 */
export async function getCustomersAndMovesForLite(
  variables: GetCustomersAndMovesForLiteQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomersAndMovesForLiteQuery['customers']>
export async function getCustomersAndMovesForLite(
  variables: GetCustomersAndMovesForLiteQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomersAndMovesForLiteQuery>
export async function getCustomersAndMovesForLite(
  variables: GetCustomersAndMovesForLiteQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomersAndMovesForLiteQuery['customers'] | GetCustomersAndMovesForLiteQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomersAndMovesForLiteQuery>(
    GetCustomersAndMovesForLiteDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}